import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  number_of_months: Yup.string().max(3, "Too many characters!").required("Required"),
  reason: Yup.string().required("Required"),
});

export const initialValues = {
  id: "",
  version: "",
  number_of_months: "",
  reason: "",
};
